import type { RankingEntry } from '@db/index';
import { useAuthStore } from '@/store/authStore';
import { cn } from '@/utils/cn';
import { RankBadge } from './RankBadge';

export const RankingTable = ({
  rankingData,
}: {
  rankingData: RankingEntry[];
}) => {
  const { profileUserId } = useAuthStore();
  return (
    <table className="grid w-full bg-white rounded-lg px-4 md:max-w-lg overflow-hidden border-4 border-yellow-500">
      <thead>
        <tr className="grid grid-cols-[80px_minmax(160px,1fr)_100px] border-b-2 border-yellow-500 text-small md:text-base">
          <th className="text-center px-[1em] py-[0.8em] pb-[0.4em] text-amber-900 font-bold">
            順位
          </th>
          <th className="text-left px-[1em] py-[0.8em] pb-[0.4em] text-amber-900 font-bold">
            プレイヤー
          </th>
          <th className="text-center px-[1em] py-[0.8em] pb-[0.4em] text-amber-900 font-bold">
            スコア
          </th>
        </tr>
      </thead>
      <tbody className="grid max-h-[50svh] h-full overflow-y-auto">
        {rankingData.map((entry) => (
          <tr
            key={`${entry.rank}-${entry.user_name}-${entry.high_score}`}
            className={cn(
              'grid grid-cols-[80px_minmax(160px,1fr)_100px] md:grid-cols-[80px_minmax(200px,1fr)_100px] items-center border-b border-gray-300  transition-colors text-lg',
              profileUserId === entry.user_id ? 'bg-amber-50' : '',
            )}
          >
            <td className="px-[1em] py-[0.8em] pb-[0.6em] text-center text-lg text-gray-600 ">
              <RankBadge rank={entry.rank ?? 0} />
            </td>
            <td
              className="px-[1em] py-[0.8em] pb-[0.6em] text-gray-600 data-[ranker='true']:font-bold data-[rank='1']:text-yellow-700 data-[rank='2']:text-gray-700 data-[rank='3']:text-orange-700"
              data-ranker={entry.rank && entry.rank <= 3 ? 'true' : 'false'}
              data-rank={entry.rank}
            >
              {entry.user_name}
            </td>
            <td
              className="px-[1em] py-[0.8em] pb-[0.6em] text-right text-gray-600 data-[ranker='true']:font-bold data-[rank='1']:text-yellow-700 data-[rank='2']:text-gray-700 data-[rank='3']:text-orange-700"
              data-ranker={entry.rank && entry.rank <= 3 ? 'true' : 'false'}
              data-rank={entry.rank}
            >
              {entry.high_score.toLocaleString()}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
